<template>
  <div class="page-404">
    <h1>404</h1>
    <p>
      Strona nie została znaleziona
    </p>
  </div>
</template>
<style lang="scss" scoped>
@use 'sass:math';
@import "@/styles/global/_variables.scss";
.page-404{
  $font-size: 120px;
  min-height: 400px;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  h1{
    font-size: $font-size;
    color: $color-main;
  }
  p{
    text-align: center;
    font-size: math.div($font-size, 4)
  }
}
</style>